export default __webpack_public_path__ + "static/media/lovrican-theme_mobile.b6360ab9.svg";